import { defaultPageInfo, KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import { isEmpty } from '@/common/utils/Util';

export default {
  init: state => {
    state.list = [];
    state.pageInfo.totalPage = 2;
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.userNo = '';
  },

  setList: (state, list) => {
    state.list = [...state.list, ...list];
  },
  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setDetail: (state, data) => {
    Object.assign(state.detail, data);
  },

  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },

  detailInit: state => {
    for (let key in state.detail) {
      state.detail[key] = '';
    }
  }
};
